import React, { FC } from 'react';
import { Dialog } from '@mui/material';
import { ContentWrapper, Subtitle, BtnClose } from './RecordErrorModal.styles';
import { useThemeLayout } from '../../hooks/useThemeLayout';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const RecordErrorModal: FC<Props> = ({ isOpen, onClose }) => {
  const { isDarkTheme } = useThemeLayout();
  
  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      sx={{ zIndex: 1000000 }}
      PaperProps={{
        sx: {
          background: isDarkTheme ? '#2C2B2B' : '#fff',
        },
      }}
    >
      <ContentWrapper
        style={{
          background: isDarkTheme ? '#2C2B2B' : '#fff',
        }}
      >
        <Subtitle color={isDarkTheme ? 'rgba(255, 255, 255, 0.80)' : '#000'}>
          {'The recorded video size is too big.'}
        </Subtitle>
        <Subtitle color={isDarkTheme ? 'rgba(255, 255, 255, 0.80)' : '#000'}>
          {'Please record a shorter video '}
        </Subtitle>
        <Subtitle color={isDarkTheme ? 'rgba(255, 255, 255, 0.80)' : '#000'}>
          {'(less than 2 min)'}
        </Subtitle>

        <BtnClose size="small" variant="contained" onClick={onClose}>
          Try again
        </BtnClose>
      </ContentWrapper>
    </Dialog>
  );
};
